/** Page size for search result fetches (overlay + encyclopedia). */
export const PAGE_SIZE = 18;
export const SKELETON_COUNT = 6;

/** Result card density. Detailed = the full stat card, compact = art + name only. */
export const DENSITY_DETAILED = 'detailed';
export const DENSITY_COMPACT = 'compact';

/* Each surface remembers its own density: the encyclopedia is for browsing and
   comparing, the slot and exclusion pickers are for finding one item you already
   have in mind, and wanting tiles in one is no reason to want them in the other. */
export const DENSITY_SCOPE_ENCYCLOPEDIA = 'encyclopedia';
export const DENSITY_SCOPE_SLOT = 'slot';
export const DENSITY_SCOPE_BLACKLIST = 'blacklist';
const DENSITY_KEY_PREFIX = 'dofgen_search_density';

/* What each surface opens on before anyone touches the toggle. The encyclopedia
   is for browsing and comparing, so it wants the stat cards; the two pickers are
   for finding one item you already have in mind, where tiles fit three times as
   many candidates on screen and the hover panel carries the detail. */
const DENSITY_DEFAULTS = {
    [DENSITY_SCOPE_ENCYCLOPEDIA]: DENSITY_DETAILED,
    [DENSITY_SCOPE_SLOT]: DENSITY_COMPACT,
    [DENSITY_SCOPE_BLACKLIST]: DENSITY_COMPACT,
};

const densityKey = (scope) => `${DENSITY_KEY_PREFIX}_${scope}`;

export function readSearchDensity(scope) {
    try {
        const stored = localStorage.getItem(densityKey(scope));
        if (stored === DENSITY_DETAILED || stored === DENSITY_COMPACT) return stored;
    } catch (e) {
        // localStorage unavailable
    }
    return DENSITY_DEFAULTS[scope] || DENSITY_DETAILED;
}

export function writeSearchDensity(scope, density) {
    try {
        localStorage.setItem(densityKey(scope), density);
    } catch (e) {
        // localStorage unavailable
    }
}
